define('models/validator/year',["backbone",
        "models/validator/_base/basevalidator"
], function (Backbone, BaseValidator) {
    "use strict";

    return BaseValidator.extend({

        defaults: {
            validationType: (enums != undefined) ? enums.validationType.month : 5
        },

        validate: function(val) {
            this.set('value', val);
            var code = this.validateHasValue(val);
            if ( this.isValid(code) ) {
                code = this.validateYear(val);
            }
            
            this.set('validationCode', code);
            return code;
        },

        validateYear: function(val) {
            val = parseInt(val);
            var code;
            if (val == -1) {
                code = enums.validationCode.empty;
            } else if (/\d{4}/.test(val)) {
                code = enums.validationCode.ok;
            } else if (/\d{2}/.test(val)) {
                code = enums.validationCode.ok;
            } else {
                code = enums.validationCode.incorrectFormat;
            }
            return code;
        }
    });
});
